

































import { Component, Vue, Prop } from 'vue-property-decorator'


@Component
export default class BackofficeAvaliacaoPreOperatoria extends Vue {
  @Prop() item!: any
}
